import { api } from "./configs/axiosConfigs"

export const PriceListProductsAPI = {

    getPriceListProduct: async (data: any) => {
        const response = await api.get(
            '/pricelistproducts', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    createPriceListProduct: async (data: any) => {
        const response = await api.post(
            '/pricelistproducts/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    editPriceListProduct: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/pricelistproducts/${idlist}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    deletePriceListProduct: async (idlist: number) => {
        const response = await api.delete(
            `/pricelistproducts/${idlist}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    deleteDetail: async (id: number) => {
        const response = await api.delete(
            `/pricelistproducts/detail/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}